import { Chart } from 'chart.js';
Chart.defaults.color = '#b0b0b0';
export var scales = {
  y: {
    display: true,
    ticks: {
      suggestedMin: 0 // minimum will be 0, unless there is a lower value.
    },

    gridLines: {
      color: '#606060',
      zeroLineColor: '#606060'
    }
  }
};
export var color_rose = '#e7c9e5';
export var color_blue = '#64a6bd';
export var backgroundChartDiv = '#404040';
export default {};